import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import HomeslayLanding from './Components/Hero/Hero';
import AboutAppSection from './Components/AboutUs/AboutUs';
import AppFeaturesSection from './Components/AppFeatures/AppFeatures';
import AppInterface from './Components/AppInterface/AppInterface';
import Review from './Components/Review/Review';
import Footer from './Components/Footer/Footer';
import ContactPage from './Components/ContactUs/ContactPage';

function App() {
  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            <div className="App">
              <div id="home">
                <HomeslayLanding />
              </div>

              <div id="about">
                <AboutAppSection />
              </div>

              <div id="features">
                <AppFeaturesSection />
              </div>

              <div id="interface">
                <AppInterface />
              </div>

              <div id="review">
                <Review />
              </div>

              <div id="footer">
                <Footer />
              </div>
            </div>
          }
        />

        <Route path="/support" element={<ContactPage />} />
      </Routes>
    </Router>
  );
}

export default App;
